exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-organisms-Question-___Question__question___2EE8t {\n  height: calc(100% - 60px);\n  width: 100%;\n  margin-top: 60px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.src-sp-components-organisms-Question-___Question__questionTitle___1Meht {\n  margin-bottom: 32px;\n}\n\n.src-sp-components-organisms-Question-___Question__choiceSet___1EOdu {\n  overflow: scroll;\n  height: 100%\n}\n", ""]);

// exports
exports.locals = {
	"question": "src-sp-components-organisms-Question-___Question__question___2EE8t",
	"questionTitle": "src-sp-components-organisms-Question-___Question__questionTitle___1Meht",
	"choiceSet": "src-sp-components-organisms-Question-___Question__choiceSet___1EOdu"
};